import { Inject, Injectable } from '@angular/core';
import { ApiService, getEmbeddedCollection, TemplateParser, TEMPLATE_PARSER } from '@mode/shared/util-halogen';
import { from, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { toMetric } from '../data-mappers/metric-data-mappers';
import { metricsCache } from '../resource-cache';
import { MetricResource } from './metric-response.types';

@Injectable({
  providedIn: 'root',
})
export class MetricClientService {
  private readonly _metricsEntry = this.urlTemplateService.parse('/api/{username}/dbt_metrics');
  private readonly _metricEntry = this.urlTemplateService.parse('/api/{username}/dbt_metrics/{metricToken}');

  constructor(
    private apiService: ApiService,
    @Inject(TEMPLATE_PARSER) private urlTemplateService: TemplateParser
  ) {}

  getMetrics(username: string) {
    return from(
      this.apiService.getFromPath<MetricResource>(this._metricsEntry.expand({ username }), {
        includes: {
          metrics: 'metric_attrs',
        },
      })
    ).pipe(
      map((resource) => getEmbeddedCollection<MetricResource>(resource, 'metrics') || []),
      map((resources) => resources.map(toMetric))
    );
  }

  getMetric(username: string, metricToken: string) {
    const cached = metricsCache.get(metricToken);

    if (cached == null) {
      return from(
        this.apiService.getFromPath<MetricResource>(this._metricEntry.expand({ username, metricToken }), {
          includes: 'metric_attrs',
        })
      ).pipe(
        tap((resource) => metricsCache.set(metricToken, resource)),
        map(toMetric)
      );
    } else {
      return of(cached).pipe(map(toMetric));
    }
  }
}
